// extracted by mini-css-extract-plugin
export var wrapper = "text-read-more-module--wrapper--7bTaZ";
export var visible = "text-read-more-module--visible--HQhn+";
export var fadein = "text-read-more-module--fadein--LcEGx";
export var hidden = "text-read-more-module--hidden--8oi8W";
export var readmoreText = "text-read-more-module--readmoreText--JK4pz";